<template>
  <div v-if="!showAdmin">
    <div class="vertical-nav bg-main" :class="{active: isActive}" id="sidebar">
      <div v-if="$store.getters.gatehouses.length === 1" class="nav_gatehouse">
        {{ $store.getters.gatehouses[0].name }}
      </div>
      <select v-else v-model="selectedGatehouseSlug" @change="changeSelectedGatehouse" id="gatehouse" class="form-select nav_select">
        <option
          v-for="gatehouse in $store.getters.gatehouses"
          :key="gatehouse.slug"
          :value="gatehouse.slug">
          {{ gatehouse.name }}
        </option>
      </select>

      <router-link class="nav-link" :to="`/${$store.getters.selectedGatehouse.slug}/dashboard`">
        <icon icon="CalendarNavbar" class="me-3 icon"></icon>
        {{ $t("navbar.dashboard") }}
      </router-link>

      <router-link class="nav-link" :to="`/${$store.getters.selectedGatehouse.slug}/vehicle-entries`">
        <icon icon="VehicleTruck" class="me-3 icon"></icon>
        {{ $t("navbar.vehicles") }}
      </router-link>

      <router-link v-if="$store.getters.hasGatehousePerm('add_vehicleentry')" class="nav-link" :to="`/${$store.getters.selectedGatehouse.slug}/vehicle-entries/add`">
        <icon icon="VehicleAddNavbar" class="me-3 icon"></icon>
        {{ $t("navbar.vehicleAdd") }}
      </router-link>

      <router-link v-if="$store.getters.selectedGatehouse.settings && $store.getters.selectedGatehouse.settings.vehicle_nfc_enabled" class="nav-link" :to="`/${$store.getters.selectedGatehouse.slug}/vehicle-nfc/entries`">
        <icon icon="NfcTagNavbar" class="me-3 icon"></icon>
        {{ $t("navbar.vehicleNfc") }}
      </router-link>

      <router-link class="nav-link" :to="`/${$store.getters.selectedGatehouse.slug}/guestbooks`">
        <icon icon="Users" class="me-3 icon"></icon>
        {{ $t("navbar.guestbooks") }}
      </router-link>

      <router-link v-if="$store.getters.hasGatehousePerm('add_guestbook')" class="nav-link" :to="`/${$store.getters.selectedGatehouse.slug}/guestbooks/add`">
        <icon icon="UserPlus" class="me-3 icon"></icon>
        {{ $t("navbar.guestbookAdd") }}
      </router-link>

      <!-- <router-link v-if="$store.getters.hasGatehousePerm('view_patrolroute')" class="nav-link" :to="`/${$store.getters.selectedGatehouse.slug}/patrols`">
        <icon icon="PatrolRouteNavbar" class="me-3 icon"></icon>
        {{ $t("navbar.patrolRoutes") }}
      </router-link>

      <router-link v-if="$store.getters.hasGatehousePerm('view_patrollog')" class="nav-link" :to="`/${$store.getters.selectedGatehouse.slug}/patrol-logs`">
        <icon icon="PatrolLogNavbar" class="me-3 icon"></icon>
        {{ $t("navbar.patrolLogs") }}
      </router-link> -->

      <router-link v-if="$store.getters.hasGatehousePerm('view_repeatingevent')" class="nav-link" :to="`/${$store.getters.selectedGatehouse.slug}/repeating-events`">
        <icon icon="RepeatNavbar" class="me-3 icon"></icon>
        {{ $t("navbar.recurringEvents") }}
      </router-link>

      <router-link class="nav-link" to="/logout">
        <icon icon="Logout" class="me-3 icon"></icon>
        {{ $t("navbar.logout") }}
      </router-link>

      <div v-if="$store.getters.hasGatehousePerm('view_gatehousepermission')" class="px-3 pt-3">
        <router-link :to="`/dashboard/${$store.getters.selectedGatehouse.slug}/gatehouse`">
          <button class="btn btn-outline-primary py-2 fw-bold text-uppercase w-100">
            {{ $t("navbar.adminPanel") }}
          </button>
        </router-link>
      </div>

      <div class="nav-bottom">
        <ChangeLang />
        <button v-if="!isActive" id="sidebarCollapse" type="button" class="d-lg-none btn btn-light bg-primary shadow-sm w-100 rounded-0 fw-bold text-white mt-2" @click="toggleMenu()">
          <small class="text-uppercase font-weight-bold">
            <span>{{ $t("utils.close") }}</span>
          </small>
        </button>
      </div>
    </div>
  </div>


  <div v-if="showAdmin">
    <div class="vertical-nav bg-main" :class="{active: isActive}" id="sidebar">
      <div v-if="$store.getters.gatehouses.length === 1" class="nav_gatehouse">
        {{ $store.getters.gatehouses[0].name }}
      </div>
      <select v-else v-model="selectedGatehouseSlug" @change="changeSelectedGatehouse" id="gatehouse" class="form-select nav_select">
        <option
          v-for="gatehouse in $store.getters.gatehouses"
          :key="gatehouse.slug"
          :value="gatehouse.slug">
          {{ gatehouse.name }}
        </option>
      </select>

      <router-link class="nav-link" :to="`/dashboard/${$store.getters.selectedGatehouse.slug}/gatehouse`">
        <icon icon="GatehouseNavbar" class="me-3 icon"></icon>
        {{ $t("navbar.gatehouse") }}
      </router-link>

      <router-link class="nav-link" :to="`/dashboard/${$store.getters.selectedGatehouse.slug}/users`">
        <icon icon="Users" class="me-3 icon"></icon>
        {{ $t("navbar.users") }}
      </router-link>

      <router-link class="nav-link" :to="`/dashboard/${$store.getters.selectedGatehouse.slug}/units`">
        <icon icon="CommodityUnitNavbar" class="me-3 icon"></icon>
        {{ $t("navbar.commodityUnits") }}
      </router-link>

      <router-link class="nav-link" :to="`/dashboard/${$store.getters.selectedGatehouse.slug}/mobile-devices`">
        <icon icon="MobileDeviceNavbar" class="me-3 icon"></icon>
        {{ $t("navbar.devices") }}
      </router-link>

      <router-link class="nav-link" :to="`/dashboard/${$store.getters.selectedGatehouse.slug}/patrols`">
        <icon icon="PatrolRouteNavbar" class="me-3 icon"></icon>
        {{ $t("navbar.patrolRoutes") }}
      </router-link>

      <router-link class="nav-link" :to="`/dashboard/${$store.getters.selectedGatehouse.slug}/nfc`">
        <icon icon="NfcTagNavbar" class="me-3 icon"></icon>
        {{ $t("navbar.nfcTags") }}
      </router-link>

      <router-link class="nav-link" :to="`/dashboard/${$store.getters.selectedGatehouse.slug}/patrol-logs`">
        <icon icon="PatrolLogNavbar" class="me-3 icon"></icon>
        {{ $t("navbar.patrolLogs") }}
      </router-link>

      <router-link class="nav-link" :to="`/dashboard/${$store.getters.selectedGatehouse.slug}/patrol-photos`">
        <icon icon="PatrolPhotoNavbar" class="me-3 icon"></icon>
        {{ $t("navbar.patrolPhotos") }}
      </router-link>

      <router-link class="nav-link notifications-link" :to="`/dashboard/${$store.getters.selectedGatehouse.slug}/notifications`">
        <icon icon="NotificationNavbar" class="me-3 icon"></icon>
        {{ $t("navbar.notifications") }}
        <span v-if="notificationCount > 0" class="notification-badge">
          {{ notificationCount }}
        </span>
      </router-link>

      <router-link class="nav-link" to="/logout">
        <icon icon="Logout" class="me-3 icon"></icon>
        {{ $t("navbar.logout") }}
      </router-link>

      <div class="px-3 pt-3 d-flex flex-column gap-4">
        <router-link :to="`/dashboard/${$store.getters.selectedGatehouse.slug}/gatehouse/add`" class="d-block">
          <button class="btn btn-primary py-2 fw-bold text-uppercase w-100">
            {{ $t("navbar.gatehouseAdd") }}
          </button>
        </router-link>
        <router-link :to="`/${$store.getters.selectedGatehouse.slug}/dashboard`">
          <button class="btn btn-outline-primary py-2 fw-bold text-uppercase w-100">
            {{ $t("navbar.backToApp") }}
          </button>
        </router-link>
      </div>

      <div class="nav-bottom">
        <ChangeLang />
        <button v-if="!isActive" id="sidebarCollapse" type="button" class="d-lg-none btn btn-light bg-primary shadow-sm w-100 rounded-0 fw-bold text-white mt-2" @click="toggleMenu()">
          <small class="text-uppercase font-weight-bold">
            <span>{{ $t("utils.close") }}</span>
          </small>
        </button>
      </div>
    </div>
  </div>

  <div class="page-content p-3 d-inline d-lg-none" :class="{active: isActive}" id="content">
    <button v-if="isActive" id="sidebarCollapse" type="button" class="btn btn-light bg-primary shadow-sm px-4 mb-4" @click="toggleMenu()">
      <small class="text-uppercase font-weight-bold">
        <span>{{ $t("utils.open") }}</span>
      </small>
    </button>
  </div>
</template>


<script>
import ChangeLang from "@/components/ChangeLang.vue"
import Icon from '@/components/Icon.vue';

export default {
  components: {
    ChangeLang,
    Icon,
  },
  data() {
    return {
      isActive: false,
    }
  },
  methods: {
    // Sidebar toggle behavior
    toggleMenu() {
      this.isActive = !this.isActive;
    },
    changeSelectedGatehouse(event) {
      const slug = event.target.value

      if (this.showAdmin) {
        this.$router.push({
          name: "GatehouseView",
          params: { slug }
        })
      } else {
        this.$router.push({
          name: "dashboard",
          params: { slug }
        })
      }
    }
  },
  computed: {
    user: function () {
      return this.$store.getters.user
    },
    showAdmin: function () {
      if (this.$route.meta.admin != null) {
        return this.$route.meta.admin === true;
      }
      return false;
    },
    selectedGatehouseSlug: {
      get() {
        return this.$store.getters.selectedGatehouse?.slug;
      },
      set(slug) {
        this.$store.commit("selectGatehouse", slug)
      }
    },
    notificationCount() {
      return this.$store.state.notificationCount;
    }
  },
}
</script>


<style scoped lang="scss">
@import "@/scss/abstracts/variables";

.vertical-nav {
  min-width: 17rem;
  width: 17rem;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.1);
  transition: all 0.4s;
  background-color: white;
  z-index: 1050;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.nav-bottom {
  margin-top: auto;
  padding: 1rem;
}

.page-content {
  width: calc(100% - 17rem);
  margin-left: 17rem;
  transition: all 0.4s;
}

.icon {
  width: 30px;
  height: 30px;
}

.nav-link {
  display: flex;
  align-items: center;
  padding: 10px 40px;
  border-bottom: 1px solid var(--bs-white);
  font-size: 16px;
  font-weight: 500;
}

.nav-link:hover {
  color: var(--bs-primary);
  border-color: var(--bs-primary);
  border-bottom: 1px solid var(--bs-primary);
  font-weight: 600;
}

.nav-link.router-link-active {
  color: var(--bs-primary);
  border-color: var(--bs-primary);
  border-bottom: 1px solid var(--bs-primary);
  font-weight: 600;
}

.notifications-link {
  position: relative;
}

.notifications-link .nav-item-content {
  display: flex;
  align-items: center;
}

.notification-badge {
  position: absolute;
  right: 25px;
  top: 50%;
  transform: translateY(-50%);
  background: var(--bs-danger);
  color: white;
  border-radius: 50%;
  min-width: 22px;
  height: 22px;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav_select {
  padding: 15px 40px;
  border-bottom: 1px solid var(--bs-white);
  border-radius: 0;
  font-size: 16px;
  font-weight: 500;
  color: var(--bs-body-color);
}

.nav_select:hover {
  border-bottom: 1px solid var(--bs-primary);
  color: var(--bs-primary);
  font-weight: 600;
  cursor: pointer;
}

.nav_select option {
  font-size: 16px;
  padding: 10px 20px;
  line-height: 1.5;
  color: var(--bs-body-color);
  background-color: var(--bs-body-bg);
}

.nav_gatehouse {
  padding: 15px 40px;
  border-bottom: 1px solid var(--bs-white);
  border-radius: 0;
  font-size: 16px;
  font-weight: 500;
  color: var(--bs-body-color);
  background-color: var(--bs-white);
}

/* for toggle behavior */

#sidebar.active {
  margin-left: -17rem;
}

#content.active {
  width: 100%;
  margin: 0;
}

@media (max-width: 768px) {
  #sidebar {
    margin-left: -17rem;
  }
  #sidebar.active {
    margin-left: 0;
  }
  #content {
    width: 100%;
    margin: 0;
  }
  #content.active {
    margin-left: 17rem;
    width: calc(100% - 17rem);
  }
}
</style>